import React from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, Plug, ArrowRight } from 'lucide-react';
import { Hero, Band, CenterHead, IconTile, SURFACE, HAIRLINE, SHADOW, T, DemoLink } from './siteUI';
import { Breadcrumb, CtaBand } from './DemoSiteLayout';

/* User-facing API page: no code, "connect FreshRoad to your tools". Two quickstarts. */

const QUICKSTARTS = [
  {
    icon: KeyRound,
    title: 'Get your API key',
    body: 'Open Settings → API in your dashboard and create a key in one click. Keep it private — you can rotate or revoke it any time.',
    to: '/login',
    cta: 'Open dashboard',
  },
  {
    icon: Plug,
    title: 'Connect a tool',
    body: 'Paste your key into Zapier, Make, or your CRM’s webhook to trigger calls and pull transcripts automatically — no engineering needed.',
    to: '/site/book-a-demo',
    cta: 'See it in a demo',
  },
];

const DemoSiteApiUsers = () => (
  <>
    <Breadcrumb trail={['Home', 'API']} />

    <section className="py-8">
      <Hero
        eyebrow="API"
        title="Your FreshRoad API"
        deck={
          <>
            Connect FreshRoad to the
            <br />
            tools you already use.
          </>
        }
        actions={
          <>
            <DemoLink />
            <Link
              to="/login"
              className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-white px-6 py-3 text-[14px] font-semibold text-teal-700 transition-colors hover:bg-teal-50 ${HAIRLINE} ${SHADOW.card}`}
            >
              Get your API key
            </Link>
          </>
        }
      >
        Generate a key in the dashboard and plug FreshRoad into your CRM, spreadsheet, or workflow
        tool. Trigger calls, sync contacts, and collect transcripts automatically.
      </Hero>
    </section>

    <Band flush className="px-6 py-10 md:px-10">
      <CenterHead title="Two ways to get started" subtitle="Most teams are live in an afternoon." />
      <div className="mx-auto mt-8 grid max-w-[880px] gap-5 md:grid-cols-2">
        {QUICKSTARTS.map(({ icon, title, body, to, cta }) => (
          <div key={title} className={`${SURFACE.card} flex flex-col p-6`}>
            <IconTile icon={icon} />
            <p className={`mt-4 ${T.h3}`}>{title}</p>
            <p className={`mt-2 flex-1 ${T.body}`}>{body}</p>
            <Link
              to={to}
              className="mt-5 inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-teal-700 hover:text-teal-800"
            >
              {cta} <ArrowRight size={15} strokeWidth={2.2} />
            </Link>
          </div>
        ))}
      </div>
    </Band>

    <CtaBand
      title="Ready to connect FreshRoad?"
      subtitle="Book a demo and we’ll help you wire it into your stack."
      primary="Book a demo"
    />
  </>
);

export default DemoSiteApiUsers;
